import { MultiSelectOption } from '@dispatch/shared/types';
import { v4 as uuidv4 } from 'uuid';
import { dispatchClient } from '../clients';

const APIM_SERVICE_TIMEZONES_URL = (tenantId: string) =>
  `configuration/${tenantId}/timezones`;

export async function getTimeZones(tenantId: string) {
  return dispatchClient.get<MultiSelectOption[]>(
    `${APIM_SERVICE_TIMEZONES_URL(tenantId)}`,
    {
      headers: {
        'Request-ID': uuidv4(),
      },
    }
  );
}
